module.exports = __webpack_public_path__ + "img/icon-upload.e87eeaad.svg";